import { plugin, debug } from 'light-component';
import { Input } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { t } from '../../i18n';
import { Require } from '../component';
import styles from './style.module.less';
import type { ReactElement } from 'react';
import type { InputProps } from './types';

export function WidgetInputs(props: InputProps): ReactElement {
  debug.widget('dashboard input', props);
  if (props.mode === 'thumbnail') {
    return (<ThumbnailInput />);
  }
  const placeholder = (typeof props?.textPlaceholder === 'string' && props.textPlaceholder.length > 0)
    ? props.textPlaceholder : props.placeholder ?? props.title;
  return (
    <div className={props.className ?? styles.propertyItem}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title)}</span>
      </div>
      <div>
        <Input
          allowClear
          onDrop={event => event.preventDefault()}
          type='text'
          placeholder={t(placeholder)}
          disabled={props.readonly}
          value={props.value}
          status={props?.focus === props.name ? 'error' : undefined}
          onChange={({ target }) => props.onChange?.(target.value)}
          onPressEnter={() => props.onSearch?.()}
        />
      </div>
    </div>
  );
}

function ThumbnailInput(): ReactElement {
  return (
    <div className={styles.control}>
      <Icons name='AppstoreAddOutlined' className={styles.icon} />
    </div>
  );
}
plugin.register({ kind: 'widget', type: 'input', component: WidgetInputs });

